let labels = {
	productID: 'Product ID',
	Description: 'Description',
	productLines: 'Product Line',
	categories: 'Categories',
	subcategories: 'Collection',
	supercategories: 'Sub Category',
	vendors: 'Vendor',
	repGroups: "Rep Group",
	priceList: 'Price List',
	inStockOnly: 'In Stock Only?'
};

export default labels;
